import { B2BDealType, B2CDealType, CostDealType } from "@/app/constants";

import { ReactiveComponent } from "../../entities/base-component";
import { CalculationStrategy, PriceResult } from "../base/calculation.strategy";

export class DeliveryCalculationStrategy extends CalculationStrategy {
    calculate(
        component: ReactiveComponent,
        [numberOfTracks, deliveryType],
    ): PriceResult {
        if (!component || !numberOfTracks || !deliveryType) {
            return this.getDefaultResult();
        }

        return {
            price: this.calculatePriceForType(
                component,
                CostDealType,
                numberOfTracks,
                deliveryType,
            ),
            priceB2C: this.calculatePriceForType(
                component,
                B2CDealType,
                numberOfTracks,
                deliveryType,
            ),
            priceB2B: this.calculatePriceForType(
                component,
                B2BDealType,
                numberOfTracks,
                deliveryType,
            ),
        };
    }

    private calculatePriceForType(
        component: ReactiveComponent,
        dealType: string,
        numberOfTracks: number,
        deliveryType: string,
    ) {
        const priceValue = component.sum.getSystemPrice(dealType).getValue();
        if (deliveryType === "combined") {
            return priceValue;
        }
        const sum = numberOfTracks * priceValue;

        return sum;
    }
}
